// ============================================================
// KENDE — cinematic entry page · site configuration
// ------------------------------------------------------------
// HERO INTRO: "The Child" clips (5s, vertical). One clip is picked
// AT RANDOM on every page load — add more entries to HERO_CLIPS
// and they join the rotation automatically.
//
// Each clip has:
//   video — MP4 with the music (plays muted until the visitor's
//           first touch anywhere on the screen, then sound kicks in)
//   anim  — animated WebP of the same clip: exempt from all browser
//           autoplay policies, guarantees motion even where muted
//           video autoplay is blocked
// The reveal is timed to the clips: 5.0s duration + small margin.
// ============================================================
export const HERO_DURATION_MS = 5400;

export const HERO_CLIPS = [
  { id: 1, video: "/hero/clip-1.mp4", anim: "/hero/clip-1.webp?v=2" },
  { id: 2, video: "/hero/clip-2.mp4", anim: "/hero/clip-2.webp?v=2" },
  { id: 3, video: "/hero/clip-3.mp4", anim: "/hero/clip-3.webp?v=2" },
];

// Navigation — each item links to its page on kende.design
export const NAV_LINKS = [
  { id: "home", label: "Home", href: "https://kende.design/" },
  { id: "kende", label: "Kende", href: "https://kende.design/kende-calligraffiti-artist/" },
  { id: "shop", label: "Shop", href: "https://kende.design/artworks/" },
  { id: "your-room", label: "Your Room", href: "https://room.kende.design/dashboard" },
  { id: "commissions", label: "Commissions", href: "https://kende.design/opere-su-commissione/" },
  { id: "news", label: "News", href: "https://kende.design/news-progetti-kende/" },
  { id: "contacts", label: "Contacts", href: "https://kende.design/contattami/" },
];
